<template>
    <v-card>
        <v-card-title primary-title class="title text--primary font-weight-bold">
            <template v-if="status == 'PENDING'">Assigning a new tickets</template>
            <template v-else-if="status == 'PROCESSING'">Active Tickets</template>
            <template v-else-if="status == 'SOLVED'">Solved Tickets</template>
            <template v-else>My Tickets</template>
            <v-flex xs12>
                <v-chip v-for="(value,key) in $store.state.user.settings.ALLOWED_TICKETS"
                        :color="selectedTicketTypes.indexOf(value) !== -1 ? 'primary' : 'grey'"
                        @click="ticketTypeClicked(value)"
                        text-color="white">
                    {{key}}
                </v-chip>
            </v-flex>
        </v-card-title>
        <v-dialog v-model="criteria.visible" width="50%">
            <v-card>
                <v-card-title primary-title class="title font-weight-bold">
                    Custom Search Criteria
                </v-card-title>
                <v-divider/>
                <v-card-text>
                    <v-select :items="['booking','captain','passenger','user','ride']"
                              label="Entity Type"
                              v-model="criteria.form.entity_type"/>
                    <template v-if="['booking','ride','user'].indexOf(criteria.form.entity_type) !== -1">
                        <v-text-field v-model="criteria.form.entity_id" :label="criteria.form.entity_type + ' id'"/>
                    </template>
                    <template v-else-if="criteria.form.entity_type === 'passenger'">
                        <choose-passenger-multi :multi="false" v-model="criteria.form.entity_id" label="Passenger"/>
                    </template>
                    <template v-else-if="criteria.form.entity_type === 'captain'">
                        <choose-captain-multi :multi="false" v-model="criteria.form.entity_id" label="Captain"/>
                    </template>
                    <choose-user-mutli :multi="false" v-model="criteria.form.user_id" label="Solving User"/>
                    <v-btn color="primary" @click="saveCriteria">
                        Save
                    </v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-card-actions>
            <v-layout justify-end>
                <template v-if="hasPermission('SEARCH_TICKETS')">
                    <v-btn icon :disabled="loading" color="primary" flat round @click="criteria.visible = true">
                        <v-icon>
                            fa fa-search
                        </v-icon>
                    </v-btn>
                    <v-btn icon :disabled="loading" color="red" flat round v-if="criteria.active"
                           @click="criteria.active = false">
                        <v-icon>
                            fa fa-ban
                        </v-icon>
                    </v-btn>
                </template>
                <v-btn :disabled="loading" color="primary" @click="status = !status ? 'PENDING' : null">
                    <template v-if="!!status">
                        My Tickets
                    </template>
                    <template v-else>
                        Assign Tickets
                    </template>
                </v-btn>
                <template v-if="hasPermission('OTHER_TICKETS')">
                    <v-btn color="blue" @click="status = 'PROCESSING'">
                        Active Tickets
                    </v-btn>
                    <v-btn color="pink" @click="status = 'SOLVED'">
                        Solved Tickets
                    </v-btn>
                </template>
            </v-layout>
        </v-card-actions>
        <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
        <v-divider v-else/>
        <v-card-text>
            <v-layout row wrap>
                <v-flex xs12 v-if="tickets.length === 0">
                    <div class="headline deep-purple text-xs-center white--text pa-5">
                        No Tickets
                    </div>
                </v-flex>
                <v-flex xs3 v-for="ticket of tickets" style="padding: 4px;">
                    <v-card>
                        <v-card-title primary-title class="font-weight-bold primary">
                            {{ticket.type.title}}
                        </v-card-title>
                        <v-divider/>
                        <v-card-text>
                            <v-layout row wrap>
                                <v-flex xs6>
                                    Name:
                                </v-flex>
                                <v-flex xs6>
                                    {{ticket.author.first_name}} {{ticket.author.last_name}}
                                </v-flex>
                                <v-flex xs6>
                                    Type:
                                </v-flex>
                                <v-flex xs6>
                                    {{ticket.author_type.split("App\\Models\\")[1]}}
                                </v-flex>
                                <template v-if="hasPermission('OTHER_TICKETS') && ticket.user">
                                    <v-flex xs6>
                                        Assigned to:
                                    </v-flex>
                                    <v-flex xs6>
                                        {{ ticket.user.first_name }} {{ ticket.user.last_name }}
                                    </v-flex>
                                </template>
                                <template v-if="ticket.subject">
                                    <v-flex xs6>
                                        On(Type):
                                    </v-flex>
                                    <v-flex xs6>
                                        {{ticket.subject_type.split("App\\Models\\")[1]}}
                                    </v-flex>
                                    <v-flex xs6>
                                        On(Identifier):
                                    </v-flex>
                                    <v-flex xs6>
                                        <template v-if="ticket.subject.first_name">
                                            {{ticket.subject.first_name}} {{ticket.subject.last_name}}
                                        </template>
                                        ({{ticket.subject_id}})
                                    </v-flex>
                                </template>
                                <v-flex xs6>
                                    Creation Date:
                                </v-flex>
                                <v-flex xs6>
                                    {{moment(ticket.created_at).format("YYYY-MM-DD HH:mm")}}
                                </v-flex>
                            </v-layout>
                        </v-card-text>
                        <v-card-actions class="text-xs-center">
                            <v-btn v-if="ticket.status === 'PENDING'" flat color="primary" @click="clickTicket(ticket)">
                                Assign it to me
                            </v-btn>
                            <v-btn v-if="ticket.status === 'PROCESSING' || status != null" flat color="secondary"
                                   @click="showInfo(ticket)">
                                Show Info
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
                <v-flex xs12>
                    <v-pagination
                            v-model="page"
                            :length.sync="pagesCount"
                    ></v-pagination>
                </v-flex>

            </v-layout>
        </v-card-text>
    </v-card>
</template>

<script>
    import ChoosePassengerMulti from "@/components/wasilni/input/ChoosePassengerMulti";
    import ChooseCaptainMulti from "@/components/wasilni/input/ChooseCaptainMulti";
    import ChooseUserMutli from "@/components/wasilni/input/ChooseUserMutli";

    export default {
        name: "Tickets",
        title: "Tickets",
        components: {ChooseCaptainMulti, ChoosePassengerMulti, ChooseUserMutli},
        data() {
            return {
                status: null,
                tickets: [],
                loading: false,
                selectedTicketTypes: Object.values(this.$store.state.user.settings.ALLOWED_TICKETS),
                page: 1,
                pagesCount: 1,
                criteria: {
                    visible: false,
                    active: false,
                    form: {
                        entity_type: null,
                        entity_id: null,
                        types: ['author', 'subject'],
                        user_id: null
                    }
                }
            }
        },
        watch: {
            params() {
                this.getData();
            },
            "criteria.form.entity_type"() {
                this.criteria.form.entity_id = null;
            },
            "criteria.visible"(val) {
                if (val)
                    this.criteria.active = false;
            },
            "criteria.form"() {
                this.page = 1;
            }
        },
        methods: {
            saveCriteria() {
                this.criteria.visible = false;
                if (!this.criteria.form.entity_id && !this.criteria.form.user_id) {
                    window.getApp.$emit("SHOW_TOAST", "You must select both entity type and entity id to enable search", "orange");
                    return;
                }
                this.criteria.active = true
            },
            ticketTypeClicked(id) {
                if (this.selectedTicketTypes.indexOf(id) === -1)
                    this.selectedTicketTypes = [...this.selectedTicketTypes, id];

                else
                    this.selectedTicketTypes = this.selectedTicketTypes.filter(
                        i => i !== id
                    );
            },
            getData() {
                this.loading = true;
                this.axios.get(this.api.ACTIONS.TICKETS, {params: this.params})
                    .then(
                        ({data}) => {
                            this.tickets = data.data.data;
                            this.page = data.data.current_page;
                            this.pagesCount = data.data.last_page;
                        }
                    )
                    .finally(
                        () => this.loading = false
                    );
            },
            showInfo(ticket) {
                let routeData = this.$router.resolve({name: 'Ticket', params: {id: ticket.id}});
                window.open(routeData.href, '_blank');
            },
            clickTicket(ticket) {
                this.loading = true;
                this.axios.put(this.api.ACTIONS.TICKET_ASSIGN(ticket.id))
                    .then(
                        () => {
                            this.tickets = this.tickets.filter(t => t !== ticket);
                            this.showInfo(ticket);
                        }
                    )
                    .finally(
                        () => this.loading = false
                    )
            }
        },
        mounted() {
            this.getData();
        }
        ,
        computed: {
            params() {
                const params = new URLSearchParams();
                params.append("status", this.status);
                params.append("page", this.page);
                for (let id of this.selectedTicketTypes)
                    params.append("selected_ticket_types[]", id);
                if (this.criteria.active) {
                    params.append('criteria', '');
                    for (let type of this.criteria.form.types)
                        params.append('types[]', type);
                    params.append("entity_type", this.criteria.form.entity_type || "");
                    params.append("entity_id", this.criteria.form.entity_id || "");
                    params.append('user_id', this.criteria.form.user_id || "");
                }

                return params;
            }
        }
    }
</script>

<style scoped>

</style>